import downloadFileService from "../shared/services/downloadFileService";
import fileDownload from "js-file-download";

const REQUEST_DOWNLOAD_HELP = "REQUEST_DOWNLOAD_HELP";
const RESPONSE_DOWNLOAD_HELP = "RESPONSE_DOWNLOAD_HELP";
const REQUEST_DOWNLOAD_HELP_FAULURE = "REQUEST_DOWNLOAD_HELP_FAULURE";

const requestDownloadHelpFileAction = () => {
  return {
    type: REQUEST_DOWNLOAD_HELP,
  };
};

const responseDownloadHelpFileAction = () => {
  return {
    type: RESPONSE_DOWNLOAD_HELP,
  };
};

const requestDownloadHelpFileFailureAction = () => {
  return {
    type: REQUEST_DOWNLOAD_HELP_FAULURE,
  };
};

const downloadHelpFile = (options) => {
  return (dispatch) => {
    dispatch(requestDownloadHelpFileAction());
    
    const formats = {
      0: "pdf",
      1: "docx",
    };

    downloadFileService
      .getHelpDocuments(options)
      .then((result) => {
        fileDownload(result.data, `Руководство пользователя.${formats[options.format]}`);
        dispatch(responseDownloadHelpFileAction());
      })
      .catch((error) => {
        dispatch(requestDownloadHelpFileFailureAction());
      });
  };
};

export { REQUEST_DOWNLOAD_HELP, RESPONSE_DOWNLOAD_HELP, REQUEST_DOWNLOAD_HELP_FAULURE, downloadHelpFile };
